export default `
<div>

  <div class="grid w890">
      <project-feed-item project="project" ng-repeat="project in projects.featured" class="section-home-feed"></project-feed-item>
      <ut-load-more (load-more)="projects.loadMore()" [is-loading]="projects.isLoading" [is-last-page]="projects.isLastPage"></ut-load-more>
  </div>

</div>
`;
